function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.65 7.804a1.2 1.2 0 110 2.4H9.335l.415 2.838c.022.205.194.36.4.362h1.942a2.787 2.787 0 012.788 2.547l.268 3.748a1.2 1.2 0 11-2.392.192l-.268-3.735a.395.395 0 00-.4-.352H10.15a2.81 2.81 0 01-2.776-2.429l-.612-4.197a1.2 1.2 0 011.187-1.374zm4.201-1.209a2.4 2.4 0 012.4 2.4v11.2a.8.8 0 11-1.6 0v-11.2a.8.8 0 10-1.6 0v.598a.8.8 0 11-1.6 0v-.598a2.4 2.4 0 012.4-2.4zm-6.102 10.2a.8.8 0 110 1.6h-5.2a.8.8 0 110-1.6zm-2.8-14.59a2 2 0 110 4 2 2 0 010-4z"
});

function SvgSpeciallyAbledAssistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgSpeciallyAbledAssistance;